import { useState } from 'react'

export const usePreDocument = () => {
  const [modal, setModal] = useState(false)

  return [modal, setModal]
}
